import { send } from "./send"
import { q, qq } from "../../helper/q"
import hermes from "hermes"

export const addCompareInit = () => {
  const compareButtons = qq(".js-add-to-compare")
  compareButtons.forEach(compareButton => {
    compareButton.addEventListener("click", () => {
      send(compareButton.dataset.id, "add").then(res => {
        console.log("add")
        hermes.send(
          "updateCompare",
          {
            count: res.result.items.length,
            action: "add"
          },
          true
        )
        q("span", compareButton).innerHTML = compareButton.dataset.messagealreadyadd
        compareButton.disabled = true
      })
    })
  })
}

export const checkCompare = () => {
  const compareButtons = qq(".js-add-to-compare")
  send("", "get").then(result => {
    const arr = result.result.items.map(item => item.id)
    compareButtons.map(button => {
      if (arr.indexOf(button.dataset.id) != -1) {
        button.disabled = true
        q("span", button).innerHTML = `${button.dataset.messagealreadyadd}`
      } else {
        button.disabled = false
        q("span", button).innerHTML = `${button.dataset.message}`
      }
    })
  })
}

export const updateIcon = data => {
  const sideCartElement = document.querySelector(".buttonCompareWrap")
  const compareElement = document.querySelector(".buttonCompare")
  const compareElementQuantity = document.querySelector(".buttonCompare span")
  const compareMobileElementQuantity = q(".menuMobileCompareQuantity")
  if (data.action === "add") {
    setTimeout(() => {
      if (sideCartElement) {
        clearTimeout(timeout)
        compareElementQuantity.classList.add("basketAnimate")
        const timeout = setTimeout(() => {
          compareElementQuantity.classList.remove("basketAnimate")
        }, 1000)
      }
    }, 500)
  }
  compareElement.value = data.count
  compareMobileElementQuantity.innerHTML = data.count
}
